<ng-template #ambiguitiesManagerModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Ambiguities Manager</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
      <i class="ft-x"></i>
    </button>
  </div>

  <div class="modal-body">
    <!-- KPI Dashboard Cards by Priority -->
    <div class="dashboard-cards">
      <!-- Unanswered Ambiguities -->
      <div class="row mb-4">
        <div class="col-12 mb-3">
          <h5 class="section-title">Unanswered Ambiguities</h5>
        </div>

        <div class="col-md-4 mb-3">
          <div class="kpi-card kpi-high"
               [class.empty]="getAmbiguitiesByStateAndPriority('unanswered', 'high').length === 0"
               (click)="showFilteredAmbiguities('unanswered', 'high')">
            <div class="kpi-icon"><i class="ft-alert-circle"></i></div>
            <div class="kpi-content">
              <div class="kpi-label">High Priority</div>
              <div class="kpi-value">{{getAmbiguitiesByStateAndPriority('unanswered', 'high').length}}</div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-3">
          <div class="kpi-card kpi-medium"
               [class.empty]="getAmbiguitiesByStateAndPriority('unanswered', 'medium').length === 0"
               (click)="showFilteredAmbiguities('unanswered', 'medium')">
            <div class="kpi-icon"><i class="ft-alert-triangle"></i></div>
            <div class="kpi-content">
              <div class="kpi-label">Medium</div>
              <div class="kpi-value">{{getAmbiguitiesByStateAndPriority('unanswered', 'medium').length}}</div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-3">
          <div class="kpi-card kpi-low"
               [class.empty]="getAmbiguitiesByStateAndPriority('unanswered', 'low').length === 0"
               (click)="showFilteredAmbiguities('unanswered', 'low')">
            <div class="kpi-icon"><i class="ft-info"></i></div>
            <div class="kpi-content">
              <div class="kpi-label">Low</div>
              <div class="kpi-value">{{getAmbiguitiesByStateAndPriority('unanswered', 'low').length}}</div>
            </div>
          </div>
        </div>

        <!-- KB Agent: Selection + Launch / Progress -->
        <div class="col-12 mt-2">
          <!-- Normal state: buttons -->
          <div class="d-flex justify-content-center" *ngIf="!agentSearching">
            <div class="d-flex align-items-center" style="gap: 1.5rem;">
              <button class="btn resolution-btn" (click)="findAutomaticKbMatches()">
                <i class="ft-search me-2 mr-1"></i>
                Search KB
              </button>
              <button class="btn btn-agent-selection" (click)="openAgentSelectionModal()">
                <span class="agent-count-badge" *ngIf="getAgentSelectionCount() > 0">{{getAgentSelectionCount()}}</span>
                <i class="ft-list me-1 mr-1"></i>
                {{getAgentSelectionCount() > 0 ? 'Edit selection' : 'Select ambiguities'}}
              </button>
            </div>
          </div>

          <!-- Searching state: progress bar -->
          <div class="agent-progress-container" *ngIf="agentSearching">
            <div class="d-flex align-items-center justify-content-between mb-1">
              <small class="agent-progress-text">
                Searching KB... {{agentProgress.current}}/{{agentProgress.total}}
              </small>
              <button class="btn btn-sm btn-agent-stop" (click)="stopAgentSearch()">
                <i class="ft-x me-1 mr-1"></i> Stop
              </button>
            </div>
            <div class="agent-progress-track">
              <div class="agent-progress-fill"
                   [style.width.%]="agentProgress.total > 0 ? (agentProgress.current / agentProgress.total * 100) : 0">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Answered Ambiguities -->
      <div class="row mb-4">
        <div class="col-12 mb-3">
          <h5 class="section-title">Answered Ambiguities</h5>
        </div>

        <div class="col-md-4 mb-3">
          <div class="kpi-card kpi-high"
               [class.empty]="getAmbiguitiesByStateAndPriority('answered', 'high').length === 0"
               (click)="showFilteredAmbiguities('answered', 'high')">
            <div class="kpi-icon"><i class="ft-alert-circle"></i></div>
            <div class="kpi-content">
              <div class="kpi-label">High Priority</div>
              <div class="kpi-value">{{getAmbiguitiesByStateAndPriority('answered', 'high').length}}</div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-3">
          <div class="kpi-card kpi-medium"
               [class.empty]="getAmbiguitiesByStateAndPriority('answered', 'medium').length === 0"
               (click)="showFilteredAmbiguities('answered', 'medium')">
            <div class="kpi-icon"><i class="ft-alert-triangle"></i></div>
            <div class="kpi-content">
              <div class="kpi-label">Medium</div>
              <div class="kpi-value">{{getAmbiguitiesByStateAndPriority('answered', 'medium').length}}</div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-3">
          <div class="kpi-card kpi-low"
               [class.empty]="getAmbiguitiesByStateAndPriority('answered', 'low').length === 0"
               (click)="showFilteredAmbiguities('answered', 'low')">
            <div class="kpi-icon"><i class="ft-info"></i></div>
            <div class="kpi-content">
              <div class="kpi-label">Low</div>
              <div class="kpi-value">{{getAmbiguitiesByStateAndPriority('answered', 'low').length}}</div>
            </div>
          </div>
        </div>

        <div class="col-12 text-center mt-2" *ngIf="hasAnsweredAmbiguities()">
          <button class="btn resolution-btn" (click)="submitResolutions()">
            <i class="ft-upload me-2"></i>
            Submit All Resolutions
          </button>
        </div>
      </div>

      <!-- Solved Ambiguities -->
      <div class="row" *ngIf="getAmbiguitiesByState('solved').length > 0">
        <div class="col-12 mb-3">
          <h5 class="section-title">Solved Ambiguities</h5>
        </div>

        <div class="col-md-4 mb-3">
          <div class="kpi-card solved kpi-high"
               [class.empty]="getAmbiguitiesByStateAndPriority('solved', 'high').length === 0"
               (click)="showFilteredAmbiguities('solved', 'high')">
            <div class="kpi-icon"><i class="ft-alert-circle"></i></div>
            <div class="kpi-content">
              <div class="kpi-label">High Priority</div>
              <div class="kpi-value">{{getAmbiguitiesByStateAndPriority('solved', 'high').length}}</div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-3">
          <div class="kpi-card solved kpi-medium"
               [class.empty]="getAmbiguitiesByStateAndPriority('solved', 'medium').length === 0"
               (click)="showFilteredAmbiguities('solved', 'medium')">
            <div class="kpi-icon"><i class="ft-alert-triangle"></i></div>
            <div class="kpi-content">
              <div class="kpi-label">Medium</div>
              <div class="kpi-value">{{getAmbiguitiesByStateAndPriority('solved', 'medium').length}}</div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-3">
          <div class="kpi-card solved kpi-low"
               [class.empty]="getAmbiguitiesByStateAndPriority('solved', 'low').length === 0"
               (click)="showFilteredAmbiguities('solved', 'low')">
            <div class="kpi-icon"><i class="ft-info"></i></div>
            <div class="kpi-content">
              <div class="kpi-label">Low</div>
              <div class="kpi-value">{{getAmbiguitiesByStateAndPriority('solved', 'low').length}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
  </div>
</ng-template>

<!-- Filtered Ambiguities Modal -->
<ng-template #filteredAmbiguitiesModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      {{filterTitle}}
      <span class="badge ms-2" [ngClass]="getStateBadgeClass(currentFilter.state)">
        {{currentFilter.state | titlecase}}
      </span>
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
      <i class="ft-x"></i>
    </button>
  </div>

  <div class="modal-body">
    <div class="ambiguities-list">
      <div
        *ngFor="let ambiguity of filteredAmbiguities; let i = index"
        class="ambiguity-item"
        [class.solved]="ambiguity.stato === 'solved'"
        (click)="openAmbiguityDetails(ambiguity)">
        <div class="header-section">
          <div class="d-flex align-items-center flex-grow-1"> <!-- Wrapper per ID, Descrizione, Badge KB -->
            <span class="badge me-2 mr-1" [ngClass]="{'solved-badge': ambiguity.stato === 'solved'}">
                {{ambiguity.id}}
              </span>
            <span class="badge me-1 mr-1" [ngClass]="getPriorityBadgeClass(getEffectivePriority(ambiguity))"
                  style="font-size: 0.65rem;">
                {{getEffectivePriority(ambiguity)}}
              </span>
            <span class="badge-ambiguity-type me-1 mr-1" *ngIf="ambiguity.type">{{ambiguity.type}}</span>
            <h5 class="d-inline ml-1 me-2">{{ambiguity.description}}</h5>
            <span class="badge bg-info ms-auto" *ngIf="hasLinkedKbItems(ambiguity)"> <!-- Usato ms-auto per spingere a destra -->
                <i class="ft-link me-1"></i> {{getLinkedKbItemsCount(ambiguity)}} KB Items
              </span>
            <span class="badge ms-1" [ngClass]="getConfidenceBadgeClass(ambiguity.agentResult?.confidence)" *ngIf="hasAgentResult(ambiguity)">
                <i class="ft-cpu me-1"></i> Agent
              </span>
          </div>

          <!-- NUOVO Pulsante Check (mostrato solo per lo stato 'answered') -->
          <button
            *ngIf="currentFilter.state === 'answered'"
            type="button"
            class="btn btn-sm check-btn ms-2"
            [class.btn-outline-secondary]="!isAmbiguityChecked(ambiguity)"
            [class.btn-success]="isAmbiguityChecked(ambiguity)"
            (click)="toggleAmbiguityChecked(ambiguity, $event)"
            [title]="isAmbiguityChecked(ambiguity) ? 'Mark as needs review' : 'Mark as checked & correct'">
            <i class="ft-check"></i>
          </button>
        </div>
        <div class="content-section">
          <div class="section-label clarification-label">
            <i class="ft-help-circle text-purple-500"></i>
            <strong>Clarification Needed</strong>
          </div>
          <div class="section-content">
            {{ambiguity.clarification_needed}}
          </div>
        </div>
      </div>

      <!-- Empty state message -->
      <div class="empty-state" *ngIf="filteredAmbiguities.length === 0">
        <i class="ft-info"></i>
        <p>No ambiguities found for the selected criteria.</p>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="backToManager()">
      <i class="ft-arrow-left me-1"></i> Back to Manager
    </button>
    <button
      type="button"
      class="btn btn-primary"
      *ngIf="currentFilter.state === 'answered'"
      (click)="submitFilteredResolutions()">
      <i class="ft-upload me-1"></i> Submit All
    </button>
  </div>
</ng-template>

<!-- Ambiguity Details Modal (Updated with KB integration) -->
<ng-template #ambiguityDetailsModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      Ambiguity Details
      <span class="badge ms-2" [ngClass]="getStateBadgeClass(selectedAmbiguity.stato)">
        {{ selectedAmbiguity.stato | titlecase }}
      </span>
    </h4>

    <div class="d-flex align-items-center ms-auto me-3" style="gap: 0.5rem;">
      <button class="btn btn-sm btn-outline-secondary" (click)="navigateAmbiguity(-1)"
              [disabled]="getAmbiguityIndex() <= 0" title="Previous">
        <i class="ft-chevron-left"></i>
      </button>
      <small class="text-muted">{{getAmbiguityIndex() + 1}} / {{filteredAmbiguities.length}}</small>
      <button class="btn btn-sm btn-outline-secondary" (click)="navigateAmbiguity(1)"
              [disabled]="getAmbiguityIndex() >= filteredAmbiguities.length - 1" title="Next">
        <i class="ft-chevron-right"></i>
      </button>
    </div>

    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
      <i class="ft-x"></i>
    </button>
  </div>

  <div class="modal-body position-relative min-height-modal">
    <!-- Main Content -->
    <div class="ambiguity-item">
      <div class="header-section d-flex justify-content-between align-items-start">
        <div>
          <span class="badge me-2">{{selectedAmbiguity.id}}</span>
          <h5 class="d-inline ml-1">{{selectedAmbiguity.description}}</h5>
        </div>
        <button
          *ngIf="selectedAmbiguity.stato !== 'solved'"
          class="btn btn-link text-danger p-0"
          (click)="deleteAmbiguity(selectedAmbiguity.id)"
          title="Delete this ambiguity">
          <i class="ft-trash-2" style="font-size: 24px;"></i>
        </button>
      </div>

      <!-- Rest of the modal content (unchanged) -->
      <div class="content-section mt-3">
        <div class="section-label clarification-label">
          <i class="ft-help-circle text-purple-500"></i>
          <strong>Clarification Needed</strong>
        </div>
        <div class="section-content">
          {{selectedAmbiguity.clarification_needed}}
        </div>

        <div class="section-label impact-label mt-3">
          <i class="ft-alert-triangle text-orange-500"></i>
          <strong>Impact</strong>
        </div>
        <div class="section-content">
          {{selectedAmbiguity.impact}}
        </div>

        <!-- Knowledge Base Link Section -->
        <div class="section-label kb-label mt-3" *ngIf="hasLinkedKbItems(selectedAmbiguity)">
          <i class="ft-link text-blue-500"></i>
          <strong>Linked Knowledge Base Items ({{getLinkedKbItemsCount(selectedAmbiguity)}})</strong>
        </div>
        <div class="kb-items-container" *ngIf="hasLinkedKbItems(selectedAmbiguity)">
          <div class="kb-content p-3 bg-light rounded border mb-2" *ngFor="let kbItem of selectedAmbiguity.linkedKbItems">
            <div class="d-flex justify-content-between align-items-start">
              <h6 class="mb-2">
                {{kbItem.title}}
                <span class="badge badge-source-ambiguity ms-2 ml-1"
                      *ngIf="kbItem.source_type === 'ambiguity_resolution'">
                  Ambiguity Resolution
                </span>
              </h6>
              <button
                class="btn btn-sm btn-outline-danger"
                (click)="removeKnowledgeBaseLink(kbItem.kbItemId)">
                <i class="ft-x-circle"></i>
              </button>
            </div>
            <div class="mb-2">
              <strong>Term:</strong> {{kbItem.term}}
            </div>
            <div>
              <strong>Definition:</strong> {{kbItem.definition}}
            </div>
            <div *ngIf="kbItem.examples && kbItem.examples.length > 0" class="mt-2">
              <strong>Examples:</strong>
              <ul class="mb-0 ps-3">
                <li *ngFor="let example of kbItem.examples">{{example}}</li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Agent Proposed Resolution (from KB search agent) -->
        <div class="agent-resolution-section mt-3" *ngIf="selectedAmbiguity.agentResult">
          <div class="section-label d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <i class="ft-cpu text-primary me-1 mr-1"></i>
              <strong>KB Agent Proposal</strong>
              <span class="badge ms-2 ml-1"
                    [ngClass]="getConfidenceBadgeClass(selectedAmbiguity.agentResult.confidence)"
                    *ngIf="selectedAmbiguity.agentResult.confidence">
                {{selectedAmbiguity.agentResult.confidence}}
              </span>
            </div>
            <div class="d-flex align-items-center gap-1">

              <button class="btn btn-sm btn-outline-secondary"
                      (click)="openAgentDebugModal(selectedAmbiguity)"
                      *ngIf="selectedAmbiguity.agentResult.debug && (isAdmin$ | async)">
                <i class="ft-activity me-1"></i> Debug
              </button>

              <button class="btn btn-sm btn-outline-danger ml-1"
                      (click)="clearAgentResolution(selectedAmbiguity)"
                      *ngIf="selectedAmbiguity.stato !== 'solved'">
                <i class="ft-x me-1"></i> Remove
              </button>
            </div>
          </div>

          <!-- Proposed text -->
          <div class="agent-answer-box mt-2" *ngIf="selectedAmbiguity.agentResult.proposed_text">
            <div class="agent-answer-text">
              {{selectedAmbiguity.agentResult.proposed_text}}
            </div>
          </div>

          <!-- Unresolved message -->
          <div class="agent-unresolved mt-2" *ngIf="!selectedAmbiguity.agentResult.proposed_text">
            <span class="text-muted"><i class="ft-alert-circle me-1"></i> Agent could not find a resolution in the KB.</span>
          </div>

          <!-- Sources -->
          <div class="agent-sources mt-2" *ngIf="selectedAmbiguity.agentResult.sources?.length">
            <small class="text-muted d-block mb-1">Sources:</small>
            <div class="source-item" *ngFor="let src of selectedAmbiguity.agentResult.sources">
              <i class="ft-file-text me-1 mr-1"></i>
              <strong>{{src.file_name}}</strong>
              <span class="source-quote" *ngIf="src.evidence_quote"> — {{src.evidence_quote | slice:0:120}}{{src.evidence_quote.length > 120 ? '...' : ''}}</span>
            </div>
          </div>

          <!-- Tools used -->
          <div class="agent-tools mt-2" *ngIf="selectedAmbiguity.agentResult.tools_used?.length">
            <small class="text-muted me-1 mr-1">Tools:</small>
            <span class="badge badge-tool me-1 mr-1" *ngFor="let tool of selectedAmbiguity.agentResult.tools_used">{{tool}}</span>
          </div>
        </div>


        <!-- Resolution Display (when ambiguity has a manual resolution but no KB link) -->
        <div class="resolution-section" *ngIf="selectedAmbiguity.resolution && selectedAmbiguity.stato !== 'solved' && !hasLinkedKbItems(selectedAmbiguity)">
          <div class="section-label resolution-label mt-3">
            <i class="ft-message-square text-green-500"></i>
            <strong>Resolution Preview</strong>
            <span class="badge badge-resolution-origin ms-2 ml-1" *ngIf="isResolutionModified(selectedAmbiguity) === false">
              <i class="ft-cpu me-1 mr-1"></i> Agent response
            </span>
            <span class="badge badge-resolution-modified ms-2 ml-1" *ngIf="isResolutionModified(selectedAmbiguity) === true">
              <i class="ft-edit me-1 mr-1"></i> Modified by user
            </span>
          </div>
          <div class="section-content bg-light p-3 rounded">
            {{selectedAmbiguity.resolution}}
          </div>
        </div>

        <!-- Resolution Display for solved ambiguities -->
        <div class="resolution-display" *ngIf="selectedAmbiguity.stato === 'solved'">
          <div class="section-label resolution-label mt-3">
            <i class="ft-message-square text-green-500"></i>
            <strong>Resolution</strong>
            <span class="badge badge-resolution-origin ms-2 ml-1" *ngIf="isResolutionModified(selectedAmbiguity) === false">
              <i class="ft-cpu me-1 mr-1"></i> Agent response
            </span>
            <span class="badge badge-resolution-modified ms-2 ml-1" *ngIf="isResolutionModified(selectedAmbiguity) === true">
              <i class="ft-edit me-1 mr-1"></i> Modified by user
            </span>
          </div>
          <div class="section-content">
            {{selectedAmbiguity.resolution}}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modified Modal Footer with Resolution Textarea Above Buttons -->
  <div class="modal-footer flex-column align-items-stretch p-3">
    <div class="resolution-section w-100 mb-3" *ngIf="selectedAmbiguity?.stato !== 'solved'">
      <div class="section-label resolution-label d-flex align-items-center mb-2">
        <i class="ft-message-square text-green-500 me-2 mr-1"></i>
        <strong> Your Resolution </strong>
        <span class="text-muted ms-2 ml-1" *ngIf="hasLinkedKbItems(selectedAmbiguity)">
          (Additional to KB items)
        </span>
      </div>
      <textarea
        class="form-control resolution-input w-100"
        rows="4"
        placeholder="Add your clarification for this ambiguity..."
        [(ngModel)]="selectedAmbiguity.resolution"
        (input)="updateAmbiguityState(selectedAmbiguity)">
      </textarea>
    </div>

    <div class="d-flex justify-content-end w-100">
      <button
        type="button"
        class="btn btn-sm me-auto"
        *ngIf="selectedAmbiguity?.stato === 'answered' && initialSelectedAmbiguityStateForReviewButton === 'answered'"
        [class.btn-outline-success]="!isAmbiguityChecked(selectedAmbiguity)"
        [class.btn-success]="isAmbiguityChecked(selectedAmbiguity)"
        (click)="toggleAmbiguityChecked(selectedAmbiguity)"
        [title]="isAmbiguityChecked(selectedAmbiguity) ? 'Unmark as reviewed' : 'Mark as reviewed & correct'">
        <i class="ft-check me-1"></i>
        {{ isAmbiguityChecked(selectedAmbiguity) ? 'Reviewed' : 'Mark Reviewed' }}
      </button>

      <button type="button" class="btn btn-outline-secondary me-2" (click)="modal.dismiss('Back')">Back</button>
      <button
        type="button"
        class="btn btn-success"
        *ngIf="selectedAmbiguity?.stato === 'answered' || selectedAmbiguity?.stato === 'unanswered'"
        (click)="modal.close('Save')">
        Confirm
      </button>
    </div>
  </div>
</ng-template>

<!-- Knowledge Base Selector Modal -->
<ng-template #knowledgeBaseModalSelector let-modal>
  <div class="modal-header">
    <h4 id="kb-selector-title" class="modal-title">Select Knowledge Base Item</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()" tabindex="0">
      <i class="ft-x"></i>
    </button>
  </div>

  <div class="modal-body">
    <!-- Search Box -->
    <div class="mb-4">
      <div class="input-group">
        <span class="input-group-text">
          <i class="ft-search"></i>
        </span>
        <input
          type="text"
          class="form-control"
          placeholder="Search knowledge base items..."
          [(ngModel)]="searchTerm"
          (input)="searchKnowledgeBaseItems()">
      </div>
    </div>

    <!-- Loading Indicator -->
    <div class="text-center my-5" *ngIf="isLoadingKnowledgeBase">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2">Loading knowledge base items...</p>
    </div>

    <!-- Error Message -->
    <div class="alert alert-danger" *ngIf="knowledgeBaseError">
      <i class="ft-alert-circle me-2"></i>
      {{knowledgeBaseError}}
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="!isLoadingKnowledgeBase && filteredKnowledgeBaseItems.length === 0 && !knowledgeBaseError">
      <i class="ft-database"></i>
      <p>No knowledge base items found. Try adjusting your search criteria.</p>
    </div>

    <!-- KB Items List -->
    <div class="kb-items-list">
      <div
        *ngFor="let item of filteredKnowledgeBaseItems"
        class="kb-item"
        [class.kb-item-selected]="isItemAlreadyLinked(item._id)"
        (click)="selectKnowledgeBaseItem(item)">
        <div class="kb-item-header">
          <h5>{{item.title}}</h5>
          <div>
        <span class="badge bg-success me-2" *ngIf="isItemAlreadyLinked(item._id)">
          <i class="ft-check me-1"></i> Selected
        </span>
            <span class="badge bg-info" *ngIf="item.type">{{item.type | titlecase}}</span>
          </div>
        </div>
        <div class="kb-item-content">
          <div class="term-section">
            <span class="term-label">Term:</span>
            <span class="term-value">{{item.term}}</span>
          </div>
          <div class="definition-section mt-2">
            <span class="definition-label">Definition:</span>
            <p class="definition-value">{{item.definition}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Knowledge Base Selector Modal - Updated footer with explicit done button -->
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="finishKbSelection()">
      <i class="ft-check me-1"></i> Done Selecting
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="cancelKbSelection()">Cancel</button>
  </div>
</ng-template>

<!-- Agent Selection Modal -->
<ng-template #agentSelectionModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Select Ambiguities for KB Agent</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
      <i class="ft-x"></i>
    </button>
  </div>

  <div class="modal-body">
    <!-- Quick select by priority -->
    <div class="d-flex align-items-center mb-3">
      <small class="text-muted" style="margin-right: 0.75rem;">Quick select:</small>
      <div class="d-flex align-items-center gap-2">
        <button class="btn btn-sm btn-agent-quick" (click)="selectByPriority('high')">
          <span class="badge-priority-high" style="font-size: 0.7rem; padding: 0.2rem 0.6rem;">high</span>
        </button>
        <button class="btn btn-sm btn-agent-quick" (click)="selectByPriority('medium')">
          <span class="badge-priority-medium" style="font-size: 0.7rem; padding: 0.2rem 0.6rem;">medium</span>
        </button>
        <button class="btn btn-sm btn-agent-quick" (click)="selectByPriority('low')">
          <span class="badge-priority-low" style="font-size: 0.7rem; padding: 0.2rem 0.6rem;">low</span>
        </button>
      </div>
      <button class="btn btn-sm btn-outline-secondary ms-auto" (click)="clearAgentSelection()"
              *ngIf="getAgentSelectionCount() > 0" style="font-size: 0.75rem;">
        Clear all
      </button>
    </div>

    <!-- Ambiguity list with checkboxes -->
    <div class="agent-selection-list">
      <div *ngFor="let ambiguity of getAmbiguitiesByState('unanswered')"
           class="agent-selection-item"
           [class.selected]="isSelectedForAgent(ambiguity.id)"
           (click)="toggleAgentSelection(ambiguity.id)">
        <div class="d-flex align-items-center">
          <div class="agent-checkbox me-2 mr-2">
            <i [class]="isSelectedForAgent(ambiguity.id) ? 'ft-check-square' : 'ft-square'"></i>
          </div>
          <span class="badge me-2 mr-1" [ngClass]="getPriorityBadgeClass(getEffectivePriority(ambiguity))"
                style="font-size: 0.65rem;">
            {{getEffectivePriority(ambiguity)}}
          </span>
          <span class="badge-ambiguity-type me-2 mr-1" *ngIf="ambiguity.type">{{ambiguity.type}}</span>
          <span class="agent-selection-id me-2 mr-1">{{ambiguity.id}}</span>
          <span class="agent-selection-desc">{{ambiguity.description}}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer d-flex justify-content-between align-items-center">
    <small class="text-muted">{{getAgentSelectionCount()}} selected</small>
    <div class="d-flex align-items-center gap-2">
      <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancel</button>
      <button type="button" class="btn resolution-btn" (click)="modal.close(); findAutomaticKbMatches()"
              [disabled]="getAgentSelectionCount() === 0">
        <i class="ft-search me-1 mr-1"></i>
        Search KB ({{getAgentSelectionCount()}})
      </button>
    </div>
  </div>
</ng-template>

<!-- Agent Debug Modal -->
<ng-template #agentDebugModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Agent Reasoning</h4>
    <div class="d-flex align-items-center">
      <button class="btn btn-sm btn-outline-secondary me-2 mr-2" (click)="copyAgentDebug()">
        <i class="ft-copy me-1"></i> {{ agentDebugCopied ? 'Copied!' : 'Copy JSON' }}
      </button>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
        <i class="ft-x"></i>
      </button>
    </div>
  </div>

  <div class="modal-body debug-modal-body" *ngIf="activeAgentDebug">
    <!-- Summary stats -->
    <div class="debug-summary mb-3">
      <div class="row">
        <div class="col-4">
          <small class="text-muted">Model</small>
          <div class="fw-bold">{{activeAgentDebug.model}}</div>
        </div>
        <div class="col-4">
          <small class="text-muted">Iterations</small>
          <div class="fw-bold">{{activeAgentDebug.total_iterations}}</div>
        </div>
        <div class="col-4">
          <small class="text-muted">Tokens</small>
          <div class="fw-bold">
            {{activeAgentDebug.total_tokens?.prompt_tokens || 0}} in /
            {{activeAgentDebug.total_tokens?.completion_tokens || 0}} out
          </div>
        </div>
      </div>
    </div>

    <!-- Question -->
    <div class="debug-question mb-3">
      <small class="text-muted d-block mb-1">Question</small>
      <code class="d-block p-2 bg-light rounded">{{activeAgentDebug.question}}</code>
    </div>

    <!-- Iterations -->
    <div class="debug-iterations">
      <div class="debug-iteration mb-3" *ngFor="let iter of activeAgentDebug.iterations; let i = index">
        <div class="d-flex align-items-center mb-2">
          <span class="badge me-2 mr-1"
                [ngClass]="iter.type === 'final_answer' ? 'bg-success' : 'bg-primary'">
            Step {{iter.iteration}}
          </span>
          <span class="text-muted">{{iter.type === 'tool_use' ? 'Tool Use' : 'Final Answer'}}</span>
          <small class="text-muted ms-auto" *ngIf="iter.tokens?.total_tokens">
            {{iter.tokens.total_tokens}} tokens
          </small>
        </div>

        <!-- Tool calls -->
        <div *ngIf="iter.type === 'tool_use' && iter.tool_calls">
          <div class="tool-call-card mb-2" *ngFor="let tc of iter.tool_calls">
            <div class="tool-call-header">
              <strong>{{tc.tool}}</strong>
              <code class="ms-2 ml-1">{{tc.args | json}}</code>
            </div>
            <pre class="tool-call-result">{{tc.result}}</pre>
          </div>
        </div>

        <!-- Final answer -->
        <div *ngIf="iter.type === 'final_answer'">
          <!-- Evidence -->
          <div *ngIf="iter.evidence?.length" class="mb-2">
            <small class="text-muted d-block mb-1">Evidence:</small>
            <div class="evidence-item" *ngFor="let ev of iter.evidence">
              <i class="ft-file-text me-1 mr-1"></i>
              <strong>{{ev.file_name}}</strong>: {{ev.quote | slice:0:200}}{{ev.quote?.length > 200 ? '...' : ''}}
            </div>
          </div>
          <div *ngIf="!iter.evidence?.length" class="text-muted mb-2">
            <i class="ft-alert-circle me-1"></i> No evidence quotes found.
          </div>

          <!-- Raw output -->
          <details class="mb-2">
            <summary class="text-muted"><small>Raw LLM output</small></summary>
            <pre class="raw-output">{{iter.raw_answer}}</pre>
          </details>

          <!-- Clean answer -->
          <div *ngIf="iter.answer" class="final-answer-box">
            <small class="text-muted d-block mb-1">Answer:</small>
            <div class="p-2 bg-light rounded">{{iter.answer}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Close</button>
  </div>
</ng-template>

<div class="d-flex justify-content-between align-items-center mb-3">
  <div class="position-relative">
    <button *ngIf="ambiguities.length > 0"
            class="btn ambiguities-btn"
            (click)="openAmbiguitiesManager()">
      <i class="fa fa-question fa-lg"></i>
    </button>
    <div *ngIf="ambiguities.length > 0"
         class="speech-bubble">
      {{ambiguities.length}} ambiguities
    </div>
  </div>
</div>
